import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .container_empty_results_wrapper {
    margin: 72px auto 155px;
    max-width: 391px;
    text-align: center;
    color: ${color.black1};
    .component_empty_results_paragraph {
      color: ${color.black3};
      .bold {
        color: ${color.black1};
      }
    }
  }
`;

export default Wrapper;
